import { useEffect, useState } from "react";
import { Form, ListGroup, Spinner } from "react-bootstrap";
import { filterData } from "../../api/common";
import moment from "moment";

const SelectSearch = ({
  disabled,
  className,
  collection,
  field,
  handledata,
  baseFilter = {},
  name,
}) => {
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState("");
  const [loading, setLoading] = useState(false);

  const ID = moment().unix();

  useEffect(() => {
    if (!search) {
      setOptions([]);
      return;
    }

    const getOptions = async () => {
      setLoading(true);
      try {
        const conditions = {
          regex: [{ [field]: search }],
          ...baseFilter,
        };

        console.log("Conditions:", conditions);
        
        const opt = await filterData(collection, conditions);
        setOptions(opt.data.data || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    getOptions();
  }, [search]);

  const handleChangeSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    setSelected("");

    if (!value) {
      handledata({
        target: { name, value: "" },
      });
    }
  };

  const handleSetValue = (label, id) => {
    setSelected(label);
    setSearch("");
    setOptions([]);

    handledata({
      target: {
        name,
        value: id,
      },
    });
  };

  return (
    <div className="position-relative">
      <Form.Control
        id={`input-text-${ID}`}
        type="text"
        value={search || selected}
        className={className}
        placeholder={name}
        onChange={handleChangeSearch}
        disabled={disabled}
        autoComplete="off"
      />

      {(loading || (options.length > 0 && search)) && (
        <ListGroup
          className="position-absolute w-100 shadow"
          style={{ zIndex: 1000, maxHeight: "250px", overflowY: "auto" }}
        >
          {loading && (
            <ListGroup.Item className="text-center">
              <Spinner animation="border" size="sm" />
            </ListGroup.Item>
          )}

          {!loading &&
            options.map((item) => (
              <ListGroup.Item
                key={item._id}
                action
                onClick={() =>
                  handleSetValue(
                    collection === "Usuarios"
                      ? `${item[field]} ${item.apellido}`
                      : item[field],
                    item._id
                  )
                }
              >
                {collection === "Usuarios"
                  ? `${item[field]} ${item.apellido}`
                  : item[field]}
              </ListGroup.Item>
            ))}
        </ListGroup>
      )}
    </div>
  );
};

export default SelectSearch;

